module.exports = __webpack_public_path__ + "assets/img/36_501_big.26cee1aa.jpg";